module.exports = __webpack_public_path__ + "img/ssclick-logo.b52248c9.jpeg";